/**
 * Dizionario es.
 *
 * Spagnolo (Fase 1 del piano per l'estero).
 *
 * Le chiavi devono essere identiche a quelle di `it`: il test
 * `backend/tests/test_jurisdictions.py::test_le_lingue_dichiarate_sono_quelle_tradotte`
 * confronta i file di questa cartella con `APP_LOCALES`, e
 * `test_b2b_frontend_wiring.py` controlla che ogni chiave usata da un pannello
 * esista in **ogni** lingua. Aggiungere una lingua è quindi un file nuovo qui
 * più il codice in `APP_LOCALES`, non una modifica a `i18n.jsx`.
 */
export default {
  "nav": {
    "showcase": "Escaparate",
    "directory": "Alojamientos",
    "network": "Red",
    "pricing": "Tarifas",
    "login": "Acceder",
    "signup": "Registrar alojamiento",
    "dashboard": "Panel",
    "logout": "Salir",
    "book": "Reservar",
    "host_area": "Gestiono un alojamiento",
    "find_stay": "Buscar alojamiento",
    "bedbank": "Bedbank",
    "claim": "Reclamar",
    "affiliates": "Afiliados",
    "merchant_area": "Área de comercio",
    "merchants": "Comercios",
    "merchant_login": "Acceso comercios",
    "merchant_login_title": "Tengo un negocio local",
    "merchant_space": "Espacio para comercios",
    "host_dashboard": "Panel del anfitrión",
    "account": "Cuenta",
    "language": "Idioma"
  },
  "landing": {
    "eyebrow": "Plataforma para alojamientos",
    "title1": "Hospitalidad italiana,",
    "title2": "en el mundo.",
    "subtitle": "Promociona tu alojamiento, sincroniza las OTAs, intercambia habitaciones con socios de confianza. Un hogar digital para B&Bs, casas rurales y hoteles.",
    "cta_primary": "Empieza gratis",
    "cta_secondary": "Ver escaparates",
    "f1_title": "Escaparate en siete idiomas",
    "f1_body": "Una página pública en italiano, inglés, español, francés, alemán, portugués y griego que cuenta tu alojamiento. Fotos, habitaciones, reserva directa con Stripe.",
    "f2_title": "Red entre alojamientos",
    "f2_body": "¿Overbooking? Deriva al huésped a un socio. Mercado nacional + grupos cerrados locales.",
    "f3_title": "Solicitudes de grupo",
    "f3_body": "Publica una solicitud de grupo grande y los alojamientos cercanos responden. Desayuno centralizado incluido.",
    "f4_title": "Calendario único",
    "f4_body": "Reservas directas, habitaciones en red, OTAs sincronizadas por iCal (en camino). Cero overbooking.",
    "f5_title": "PMS incluido",
    "f5_body": "Un verdadero Property Management System dentro de la plataforma: recepción, limpieza, cocina, compras y registro de operaciones. Sin software extra que pagar.",
    "showcase_title": "Alojamientos en escaparate",
    "showcase_sub": "Algunas de las casas que se cuentan en Hostaly.",
    "how_title": "Cómo funciona",
    "how_1": "Registra tu alojamiento",
    "how_1b": "Registro en 60 segundos. Verificación automática para el MVP.",
    "how_2": "Configura el escaparate en siete idiomas",
    "how_2b": "Textos en cada idioma, fotos, servicios, habitaciones. Publica cuando estés listo.",
    "how_3": "Entra en la red",
    "how_3b": "Ofrece habitaciones de última hora, responde a solicitudes de grupo, cobra.",
    "final_title": "El hogar digital de los alojamientos",
    "final_body": "Una sola plataforma para gestionar escaparate, red y reservas."
  },
  "auth": {
    "login": "Acceder",
    "register": "Registra tu alojamiento",
    "email": "Email",
    "password": "Contraseña",
    "structure": "Nombre del alojamiento",
    "country": "País del alojamiento",
    "country_help": "Decide qué obligaciones te aplican. No es el idioma de la interfaz: ese lo eliges aparte.",
    "cin_label": "Código CIN",
    "cin_help": "Código de Identificación Nacional MITUR — obligatorio por ley (DL 145/2023). Formato nacional: IT + 15 caracteres (17 en total). Algunas regiones como Sicilia pueden usar formatos más largos (hasta 22 caracteres). Solicítalo en bdsr.ministeroturismo.gov.it",
    "cin_not_required": "El CIN no hace falta fuera de Italia: te pediremos el número de registro local cuando toque.",
    "submit_login": "Entrar",
    "submit_register": "Crear cuenta",
    "aff_rules": "Reglas de afiliación",
    "aff_consent": "Declaro haber leído y aceptado las",
    "aff_consent_hint": "Obligatorio para registrar el alojamiento: incluye comisiones, pagos, obligaciones del alojamiento y todas las promociones del contrato (cláusula 6.4).",
    "switch_to_register": "¿No tienes cuenta? Registra el alojamiento",
    "switch_to_login": "¿Ya tienes cuenta? Accede",
    "forgot": "¿Olvidaste la contraseña?",
    "demo_hint": "Demo: demo@hospitalityhub.it / demo1234",
    "staff_title": "Crea tu cuenta",
    "staff_hint": "El titular del alojamiento te ha asignado un rol. Usa exactamente la dirección de email con la que te lo asignó: es la que vincula tu cuenta al rol.",
    "staff_name": "Nombre y apellidos",
    "staff_name_help": "Opcional. Solo sirve para que tus colegas te reconozcan.",
    "role_label": "Tu rol en el alojamiento",
    "role_general_manager": "General Manager (propietario)",
    "role_operations_manager": "Operations Manager",
    "role_manager": "Manager",
    "role_operator": "Operativo (limpieza/cocina/reparaciones)",
    "role_help": "Determina qué puedes hacer en Gestión Hotelera. El General Manager puede gestionar los roles del personal.",
    "staff_password_hint": "Al menos 8 caracteres.",
    "staff_submit": "Crear mi cuenta",
    "account_created": "Cuenta creada",
    "welcome_back": "Bienvenida/o",
    "cin_invalid": "Código CIN no válido. Debe empezar por 'IT' seguido de 14-20 caracteres alfanuméricos.",
    "cin_title": "Empieza por IT + 14-20 caracteres (16-22 en total, p. ej. Sicilia 18)",
    "aff_required": "Debes leer las Reglas de afiliación para continuar.",
    "google": "Continuar con Google",
    "apple": "Continuar con Apple",
    "soon": "pronto",
    "google_unavailable": "Inicio de sesión con Google no disponible",
    "google_not_configured": "El acceso con Google no está configurado en esta instalación. Usa email y contraseña; la clave (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET) debe añadirse en el servidor.",
    "apple_failed": "No se pudo iniciar sesión con Apple",
    "contract_docx": "Descargar el contrato completo (DOCX)",
    "costs_title": "Cuánto te cuesta Hostaly",
    "costs_body": "Sin coste de alta. La comisión se aplica a cada reserva y baja con el plan.",
    "to_staff": "¿Te han asignado un rol en un alojamiento? Crea la cuenta aquí",
    "host_plans": "Planes para anfitriones",
    "pick_plan": "Elige el plan que necesitas"
  },
  "dash": {
    "welcome": "Bienvenida,",
    "overview": "Resumen",
    "property": "Alojamiento",
    "rooms": "Habitaciones",
    "bookings": "Reservas",
    "marketplace": "Red",
    "groups": "Solicitudes de grupo",
    "reviews": "Valoraciones",
    "ical": "Sincronización OTA",
    "swaps": "Intercambios",
    "breakfast": "Desayuno",
    "total_bookings": "Reservas totales",
    "revenue": "Ingresos",
    "open_offers": "Ofertas abiertas",
    "published": "Publicado",
    "not_published": "No publicado",
    "publish": "Publicar escaparate",
    "unpublish": "Ocultar escaparate",
    "view_showcase": "Ver escaparate público",
    "copy_link": "Copiar enlace",
    "copied": "¡Copiado!",
    "save": "Guardar cambios",
    "saved": "Guardado",
    "name": "Nombre",
    "city": "Ciudad",
    "region": "Región",
    "address": "Dirección",
    "phone": "Teléfono",
    "desc_it": "Descripción (IT)",
    "desc_en": "Descripción (EN)",
    "amenities": "Servicios (separados por coma)",
    "hero_image": "Foto principal",
    "photos": "Galería de fotos",
    "property_type": "Tipo de alojamiento",
    "country": "País",
    "country_help": "Dónde está el inmueble: de aquí salen los identificativos y los plazos que te mostramos.",
    "locality": "Municipio / localidad",
    "currency": "Moneda",
    "currency_help": "La moneda del país. Los precios de las habitaciones y los cobros siguen en euros: el sitio convierte solo para mostrarlos.",
    "obligations_title": "Obligaciones del país",
    "obligations_hint": "Qué hay que comunicar, a quién y en qué plazo. La lista es la del país del alojamiento: si cambias de país, cambian las obligaciones.",
    "obligations_active": "Activo",
    "obligations_toggle": "Marcar como activo",
    "obligations_source": "Fuente oficial",
    "obligations_verified": "Verificado el",
    "obligations_error": "No consigo guardar la obligación",
    "timezone": "Zona horaria",
    "add_room": "Añadir habitación",
    "room_name": "Nombre de la habitación",
    "price_night": "Precio/noche (€)",
    "capacity": "Capacidad",
    "photo_url": "URL de la foto",
    "publish_offer": "Publicar en la red",
    "no_bookings": "Aún no hay reservas",
    "no_rooms": "Aún no hay habitaciones. Añade una para empezar.",
    "offer_from": "Desde",
    "offer_to": "Hasta",
    "post_group_req": "Publicar solicitud de grupo",
    "title": "Título",
    "guests": "Huéspedes",
    "budget": "Presupuesto/noche (€)",
    "notes_it": "Notas (IT)",
    "notes_en": "Notas (EN)",
    "respond": "Responder",
    "rooms_offered": "Habitaciones ofrecidas",
    "message": "Mensaje",
    "send": "Enviar respuesta",
    "responses": "respuestas",
    "total": "Total",
    "night": "noche",
    "nights": "noches",
    "upload_photo": "Subir foto",
    "uploading": "Subiendo...",
    "drop_here": "Arrastra o haz clic para subir",
    "remove": "Quitar",
    "ical_title": "Sincroniza las OTAs por iCal",
    "ical_sub": "Importa disponibilidad y reservas de Booking, Airbnb, Expedia, Vrbo.",
    "ical_url": "URL de iCal",
    "ical_source": "Plataforma",
    "ical_import": "Importar",
    "ical_last_sync": "Última sincronización",
    "ical_events": "Eventos importados",
    "calendar_unified": "Calendario unificado",
    "swap_forward": "Reenviar al socio",
    "swap_title": "Intercambio de habitación",
    "partner_property": "Alojamiento socio",
    "partner_room": "Habitación del socio",
    "commission_10": "Se aplicará una comisión del 10%",
    "swap_notes": "Notas para el socio",
    "swap_send": "Proponer intercambio",
    "no_swaps": "Aún no hay intercambios",
    "breakfast_title": "Desayuno centralizado",
    "breakfast_sub": "Ofrece o reserva desayunos para los huéspedes de la red.",
    "add_breakfast_slot": "Nuevo turno de desayuno",
    "slot_date": "Fecha",
    "slot_time": "Hora",
    "slot_max": "Plazas máximas",
    "slot_price": "Precio/plaza (€)",
    "book_covers": "Reservar plazas",
    "covers": "plazas",
    "book_slot": "Reservar",
    "available": "disponibles",
    "your_breakfast_bookings": "Tus reservas de desayuno",
    "role": "Rol",
    "date": "Fecha",
    "amount": "Importe",
    "source": "Origen",
    "event_title": "Título",
    "start": "Inicio",
    "end": "Fin",
    "no_events": "Ningún evento — importa un iCal o recibe una reserva.",
    "welcome_back": "Bienvenida",
    "toast_uploaded": "Subido",
    "toast_upload_failed": "Error al subir",
    "toast_error": "Error",
    "toast_swap_sent": "Intercambio propuesto · huésped avisado",
    "toast_slot_added": "Turno añadido",
    "toast_slot_booked": "Reservado",
    "toast_offer_posted": "Oferta publicada",
    "toast_gr_posted": "Solicitud publicada",
    "toast_response_sent": "Respuesta enviada",
    "toast_imported": "Importados {n} eventos",
    "select_room": "Selecciona habitación",
    "select_partner": "Selecciona socio",
    "select_booking": "Selecciona reserva",
    "no_paid_bookings": "Ninguna reserva pagada",
    "per_cover": "por plaza",
    "outgoing": "saliente",
    "incoming": "entrante",
    "from_label": "Desde:",
    "to_label": "Hasta:",
    "commission_10pct": "Comisión (10%)",
    "analytics": "Analítica",
    "revenue_monthly": "Ingresos mensuales",
    "direct_bookings": "Reservas directas",
    "swap_commissions": "Comisiones de intercambios",
    "breakfast_income": "Ingresos de desayuno",
    "no_analytics": "Aún no hay datos — empieza a recibir reservas.",
    "stripe_connect": "Pagos automáticos",
    "connect_start": "Activar Stripe Connect",
    "connect_continue": "Completar el alta",
    "connect_done": "Pagos activos",
    "connect_pending": "Alta en curso",
    "connect_hint": "Recibe automáticamente las reservas directas netas de la comisión de Hostaly (8% Base · 6% Pro · 4,5% Enterprise). Las comisiones de Stripe por el procesamiento de pagos corren a cargo de la cuenta conectada.",
    "accept_split": "Aceptar y repartir",
    "select_partners": "Selecciona socios",
    "allocated_rooms": "Habitaciones asignadas",
    "allocation_confirmed": "Reparto confirmado",
    "push_title": "Notificaciones del navegador",
    "push_hint": "Recibe un aviso en el dispositivo incluso con la pestaña cerrada.",
    "push_enable": "Activar notificaciones",
    "push_disable": "Desactivar",
    "push_on": "Activas",
    "push_off": "Desactivadas",
    "push_denied": "Bloqueadas por el navegador",
    "instagram": "Instagram",
    "ig_handle": "Usuario de Instagram (@)",
    "ig_posts": "Publicaciones recientes",
    "ig_add": "Añadir publicación",
    "ig_image": "URL de la imagen",
    "ig_caption": "Texto",
    "ig_link": "Enlace de la publicación",
    "verification": "Verificación",
    "verify_title": "Verificación del alojamiento",
    "verify_hint": "Los alojamientos verificados muestran la insignia ✓ en el mercado y en el escaparate.",
    "verified": "Verificado",
    "pending_verify": "Pendiente",
    "not_verified": "No verificado",
    "submit_verify": "Solicitar verificación",
    "vat_number": "NIF/CIF (11 dígitos)",
    "business_name": "Razón social",
    "municipality": "Municipio",
    "declaration": "Declaro bajo mi responsabilidad que estos datos son correctos",
    "admin": "Administración",
    "admin_pending": "Solicitudes pendientes",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "admin_note": "Nota interna",
    "ai_copy": "Generar con IA",
    "ai_copy_title": "Generar el escaparate con IA",
    "ai_copy_hint": "Escribe algunas palabras clave — la IA creará la descripción IT/EN y los servicios.",
    "ai_keywords": "Palabras clave (separadas por coma)",
    "ai_tone": "Tono",
    "ai_generate": "Generar",
    "ai_apply": "Aplicar al escaparate",
    "promo_code": "Código descuento",
    "promo_apply": "Aplicar",
    "promo_valid": "Código válido",
    "promo_saved": "Ahorras",
    "trade_nav": "Trade B2B",
    "trade_title": "Venta B2B para tour operadores y agencias",
    "trade_sub": "Compra bloques de habitaciones directamente a los alojamientos italianos a tarifas reservadas.",
    "trade_offers": "Ofertas trade",
    "trade_login": "Acceso trade",
    "trade_register": "Registrar agencia",
    "trade_company": "Nombre de la agencia / tour operador",
    "trade_vat": "NIF/CIF",
    "trade_country": "País",
    "trade_publish": "Publicar oferta trade",
    "trade_new_offer": "Nueva oferta trade",
    "trade_rooms_available": "Habitaciones disponibles",
    "trade_price_per_night": "Precio/habitación/noche (€)",
    "trade_min_nights": "Noches mínimas",
    "trade_buy": "Comprar ahora",
    "trade_orders_mine": "Mis reservas",
    "trade_sold": "vendidas",
    "trade_tab": "Trade",
    "partner_center_tab": "Partner Center",
    "channels_tab": "Canales OTA",
    "b2b_title": "Canal B2B · bedbank",
    "b2b_subtitle": "Compra tarifas netas a un bedbank, aplica tu recargo y devuelve la comisión al socio.",
    "b2b_suppliers": "Proveedores",
    "b2b_add_supplier": "Añadir proveedor",
    "b2b_mapping": "Mapeo de hoteles",
    "b2b_rules": "Reglas de precio",
    "b2b_simulator": "Simulador",
    "b2b_settlements": "Liquidaciones",
    "b2b_net": "Tarifa neta",
    "b2b_nights": "Noches",
    "b2b_markup": "Recargo",
    "b2b_rebate": "Devolución",
    "b2b_msp": "Precio mínimo (MSP)",
    "b2b_gross": "Precio al público",
    "b2b_charged": "Cobrado ahora",
    "b2b_margin": "Margen",
    "b2b_blocked": "No vendible",
    "b2b_msp_binding": "Precio limitado por el mínimo del proveedor",
    "b2b_cashback": "La devolución llega tras la reserva",
    "b2b_needed_markup": "Recargo necesario",
    "b2b_target_margin": "Margen objetivo",
    "b2b_credentials_missing": "Faltan credenciales",
    "b2b_confirmed_by": "Confirmado por",
    "b2b_auto": "Vinculado automáticamente",
    "b2b_review": "Por confirmar",
    "b2b_no_candidates": "Ningún candidato compatible",
    "b2b_partners": "Contrapartes",
    "b2b_add_partner": "Añadir contraparte",
    "b2b_partner_kind": "Tipo",
    "b2b_partner_agency": "Agencia",
    "b2b_partner_tour_operator": "Tour operador",
    "b2b_partner_hotel": "Otro hotel",
    "b2b_partner_vat": "NIF/CIF",
    "b2b_payment_terms": "Condiciones de pago",
    "b2b_credit_risk": "Riesgo de impago",
    "b2b_credit_limit": "Límite de crédito",
    "b2b_terms_agency": "Agencias y otros hoteles: sin cobro a consumidores, así que sin pago con tarjeta.",
    "b2b_outstanding": "Pendiente de pago",
    "b2b_rates": "Tarifario por contraparte",
    "b2b_net_rate": "Tarifa neta",
    "b2b_public_price": "Precio del escaparate",
    "b2b_above_public": "Por encima del precio del escaparate",
    "b2b_above_public_hint": "Estás pidiendo a la contraparte más de lo que pides a un huésped que llega del escaparate. La agencia lo nota y te rodea."
  },
  "vetrina": {
    "book": "Reservar",
    "from": "desde",
    "per_night": "/ noche",
    "rooms": "Habitaciones",
    "reviews": "Opiniones",
    "contact": "Contacto",
    "leave_review": "Deja una opinión",
    "guest_name": "Tu nombre",
    "rating": "Valoración",
    "comment": "Tu comentario",
    "submit": "Enviar opinión",
    "services": "Servicios",
    "check_in": "Entrada",
    "check_out": "Salida",
    "guest_email": "Tu email",
    "confirm_book": "Confirmar y pagar",
    "total_price": "Total",
    "processing": "Procesando...",
    "book_this_room": "Reservar esta habitación",
    "promo_code": "Código descuento",
    "promo_apply": "Aplicar",
    "promo_valid": "Código válido",
    "promo_saved": "Ahorras",
    "traveller_nudge": "¿Eres viajero?",
    "prefill_login": "Inicia sesión para rellenar tus datos →",
    "beds": "Camas",
    "beds_hint": "Precio por cama: {count} camas disponibles en este dormitorio.",
    "phone": "Teléfono",
    "phone_optional": "Teléfono (opcional)",
    "phone_placeholder": "+34 600 123 456",
    "phone_hint": "El anfitrión solo lo usará para contactarte sobre esta reserva.",
    "charged_in": "Cobro en {currency} · {amount}",
    "fx_note": "Cambio BCE: 1 EUR = {rate} {currency} ({date})",
    "fx_stale": "último cambio disponible",
    "pay_now": "Pagar ahora",
    "pay_now_hint": "Tarjeta · cargo inmediato",
    "pay_at_property": "Pagar en el alojamiento",
    "pay_at_property_hint": "Tarjeta en garantía · cargo solo si no te presentas",
    "pay_at_hotel": "Pagar en el hotel",
    "pay_at_hotel_hint": "Paga todo al llegar · se requiere tarjeta en garantía",
    "pay_at_hotel_title": "Paga todo al llegar, en el alojamiento",
    "pay_at_hotel_step1": "Ahora no se cobra nada: pagas la estancia completa al llegar, directamente en el alojamiento.",
    "pay_at_hotel_step2": "Se necesita una tarjeta de crédito válida para garantizar la reserva. No se cobra hoy: la guardamos solo como garantía.",
    "pay_at_hotel_step3": "La tarjeta solo se cobra en caso de no presentarse o de cancelación fuera de plazo, según la política del alojamiento.",
    "pay_at_hotel_total": "Total a pagar en el alojamiento",
    "pay_at_hotel_continue": "Continuar con la tarjeta en garantía",
    "pay_at_hotel_unavailable": "La garantía con tarjeta no está disponible en este momento: reserva con el pago con tarjeta o contacta con el alojamiento.",
    "paypal_hint": "Paga con tu cuenta de PayPal",
    "pay_with_paypal": "Pagar con PayPal",
    "paypal_note": "Te redirigiremos a PayPal para completar el pago de forma segura y luego volverás aquí.",
    "redirecting": "Redirigiendo…",
    "enter_email_code": "Introduce email y código",
    "invalid_code": "Código no válido",
    "phone_invalid": "Introduce un número de teléfono válido",
    "name_email_required": "Nombre y email obligatorios",
    "pick_dates": "Elige las fechas",
    "accept_policy": "Debes aceptar la política de no-show para continuar",
    "report_content": "Denunciar contenido",
    "guest_terms": "Condiciones de reserva",
    "free_cancel": "Cancelación gratuita",
    "no_show_policy": "Política de no-show",
    "penalty": "Penalización",
    "free_cancel_note": "Puedes cancelar gratis hasta {days} días antes del check-in.",
    "free_cancel_note_one": "Puedes cancelar gratis hasta 1 día antes del check-in.",
    "by_date": "Antes del {date}.",
    "then_retained": "Después se retiene el {percent}%.",
    "penalty_note": "Cancelación sujeta a penalización: {penalty}.",
    "first_night": "primera noche",
    "percent_of_total": "{percent}% del total",
    "guarantee_card": "Tarjeta en garantía",
    "no_charge_note": "No se cobrará nada ahora. Solo haremos una verificación temporal de 1 € (liberada al instante) para validar la tarjeta.",
    "no_show_consent": "Acepto que, si no me presento tras la fecha límite, se cargue el importe de {amount} en la tarjeta indicada.",
    "confirm_no_charge": "Confirmar reserva (sin cargo)",
    "please_wait": "Espera…",
    "booking_confirmed": "Reserva confirmada · Tarjeta •••• {last4} guardada en garantía",
    "verified": "Verificado",
    "guest_favourite": "Favorito de los huéspedes",
    "guest_favourite_hint": "Favorito de los huéspedes — distintivo de los alojamientos mejor valorados",
    "rates_loading": "Cargando tipos de cambio...",
    "per_bed_night": "por cama / noche",
    "dorm_badge": "Dormitorio {gender} · {beds} camas",
    "floor": "Planta {number}",
    "free_cancel_badge": "Cancelación gratuita hasta {days} días antes",
    "guest": "Huésped",
    "thanks": "¡Gracias!",
    "posting_as": "Publicas como",
    "rating_5": "Perfecto",
    "rating_4": "Bueno",
    "rating_3": "Aceptable",
    "rating_2": "Insuficiente",
    "rating_1": "Muy malo",
    "dictate_review": "Dicta tu reseña",
    "gender_mixed": "mixto",
    "gender_female": "femenino",
    "gender_male": "masculino"
  },
  "guest": {
    "my_bookings": "Mis reservas",
    "my_maps": "Mis mapas",
    "travellers_area": "Área de viajeros",
    "have_account": "¿Ya tienes cuenta?",
    "login": "Acceder",
    "signup": "Registrarse"
  },
  "pay": {
    "success": "Reserva confirmada",
    "success_body": "Recibirás un email de confirmación. ¡Gracias!",
    "cancel": "Pago cancelado",
    "cancel_body": "No se ha realizado ningún cargo.",
    "back_home": "Volver al inicio",
    "checking": "Comprobando el pago..."
  },
  "common": {
    "close": "Cerrar",
    "cancel": "Cancelar",
    "loading": "Cargando...",
    "city": "Ciudad",
    "filter_city": "Filtrar por ciudad"
  },
  "trip_group": {
    "propose_title": "Otros huéspedes en tus fechas",
    "propose_caption": "Hay un grupo de viajeros para {from} → {until}. Puedes unirte, aunque sea solo para charlar: sin obligación de viajar juntos.",
    "joined_title": "Estás en el grupo",
    "joined_caption": "El chat del grupo está abierto durante las fechas en común.",
    "join": "Unirme",
    "more": "Cómo funciona",
    "consent_note": "Al unirte activas el consentimiento para grupos de viajeros. Es genérico y revocable: sin obligación de viajar juntos.",
    "consent_enable": "Activar participación",
    "optin_badge": "Viajeros solos",
    "optin_title": "¿Viajas solo? Hay quien vive tus mismas experiencias.",
    "optin_caption": "En tus fechas hay quien visita, come y camina donde vas a ir tú: únete al grupo y comparte solo lo que te apetezca.",
    "optin_body": "La adhesión solo se confirma en el momento del viaje y puedes retirarla cuando quieras, sin consecuencias para la reserva.",
    "optin_on": "Adhesión activa",
    "optin_off": "No me adhiero",
    "optin_saved": "Preferencia guardada. Puedes cambiarla cuando quieras.",
    "optin_login": "Inicia sesión como viajero para activarla",
    "optin_error": "No puedo guardar la preferencia.",
    "login_required": "Accede para unirte al grupo.",
    "join_failed": "No consigo añadirte al grupo.",
    "cap_reached": "Ya estás en 2 grupos solapados: sal de uno para entrar en este.",
    "tooltip_title": "Grupos de viajeros",
    "tooltip_1": "Se agrupa por lugar y periodo: basta con un solo día de estancia en común.",
    "tooltip_2": "Puedes estar en varios grupos, pero como máximo dos se solapan en las mismas fechas.",
    "tooltip_3": "El chat está abierto solo durante las fechas en común: los mensajes fuera de esas fechas no llegan.",
    "tooltip_4": "Los demás miembros ven solo un nombre corto, nunca los detalles de tu reserva.",
    "tooltip_5": "Si cancelas la reserva sales del grupo; si te quedas solo, el grupo se cierra.",
    "tooltip_window": "Periodo",
    "loading": "Cargando...",
    "back": "Atrás",
    "chat_title": "Chat del grupo",
    "chat_hint": "Solo ven estos mensajes los miembros con fechas en común. No se comparte ningún detalle de la reserva.",
    "chat_failed": "No consigo cargar el chat.",
    "send_failed": "Mensaje no enviado.",
    "chat_empty": "Escribe un mensaje.",
    "no_access": "Sin acceso",
    "no_access_detail": "El chat es para los miembros con una estancia en común y está abierto solo durante las fechas compartidas.",
    "no_access_after_consent": "El consentimiento está activo, pero no formas parte de este grupo: las fechas ya no coinciden o el grupo se ha cerrado.",
    "not_found": "Grupo no encontrado",
    "no_messages": "Aún no hay mensajes. Rompe el hielo.",
    "new_message": "Nuevo mensaje",
    "message_placeholder": "Escribe algo al grupo...",
    "send": "Enviar",
    "cancel": "Cancelar",
    "announce": "Aviso",
    "announcement": "Aviso",
    "meeting": "Encuentro",
    "meeting_proposal": "Propuesta de encuentro",
    "new_meeting": "Propón un encuentro",
    "meeting_when": "Cuándo",
    "meeting_when_placeholder": "p. ej. el sábado por la mañana",
    "meeting_when_required": "Indica cuándo.",
    "meeting_where": "Dónde",
    "meeting_where_placeholder": "p. ej. la entrada del museo",
    "meeting_where_required": "Indica dónde.",
    "meeting_note": "Nota (opcional)",
    "meeting_note_placeholder": "¿Algo que añadir?",
    "propose": "Proponer",
    "members": "Miembros",
    "member_count": "Miembros: {n}",
    "no_members": "Aún no hay miembros.",
    "anonymous": "Huésped",
    "chat_ok": "En el chat",
    "chat_no": "Solo grupo"
  }
};
